import React from "react";
import { ExclamationCircleFill, CheckCircleFill, XCircleFill } from "react-bootstrap-icons";

export enum IconStatusType {
  Online,
  Offline,
  InUse,
  Processed,
  NotDue,
  InvalidConfiguration,
  OK,
  ServicesNotConfigured,
  ProvidersNotConfigured,
  ServicesInvalid,
  ConfigurationIssue,
  NotInitialised
}

export const IconStatusTypeClass: Record<IconStatusType, string> = {
  [IconStatusType.Online]: "icon-tick",
  [IconStatusType.Offline]: "icon-cross",
  [IconStatusType.InUse]: "icon-warning",
  [IconStatusType.Processed]: "icon-tick",
  [IconStatusType.NotDue]: "icon-warning",
  [IconStatusType.InvalidConfiguration]: "icon-cross",
  [IconStatusType.OK]: "icon-tick",
  [IconStatusType.ServicesNotConfigured]: "icon-cross",
  [IconStatusType.ProvidersNotConfigured]: "icon-cross",
  [IconStatusType.ServicesInvalid]: "icon-cross",
  [IconStatusType.ConfigurationIssue]: "icon-warning",
  [IconStatusType.NotInitialised]: "icon-warning",
};

export const IconStatusTypeDescription: Record<IconStatusType, string> = {
  [IconStatusType.Online]: "Online",
  [IconStatusType.Offline]: "Offline",
  [IconStatusType.InUse]: "In use",
  [IconStatusType.Processed]: "Processed",
  [IconStatusType.NotDue]: "Not Due",
  [IconStatusType.InvalidConfiguration]: "Invalid Configuration",
  [IconStatusType.OK]: "OK",
  [IconStatusType.ServicesNotConfigured]: "Services Not Configured",
  [IconStatusType.ProvidersNotConfigured]: "Providers Not Configured",
  [IconStatusType.ServicesInvalid]: "Services Invalid",
  [IconStatusType.ConfigurationIssue]: "Configuration Issue",
  [IconStatusType.NotInitialised]: "Not Initialised",
};

export const IconStatusTypeComponent: Record<IconStatusType, JSX.Element> = {
  [IconStatusType.Online]: (<CheckCircleFill size={18} className="right-margin-smallest" />),
  [IconStatusType.Offline]: (<XCircleFill size={18} className="right-margin-smallest" />),
  [IconStatusType.InUse]: (<ExclamationCircleFill size={18} className="right-margin-smallest" />),
  [IconStatusType.Processed]: (<CheckCircleFill size={18} className="right-margin-smallest" />),
  [IconStatusType.NotDue]: (<ExclamationCircleFill size={18} className="right-margin-smallest" />),
  [IconStatusType.InvalidConfiguration]: (<XCircleFill size={18} className="right-margin-smallest" />),
  [IconStatusType.OK]: (<CheckCircleFill size={18} className="right-margin-smallest" />),
  [IconStatusType.ServicesNotConfigured]: (<XCircleFill size={18} className="right-margin-smallest" />),
  [IconStatusType.ProvidersNotConfigured]: (<XCircleFill size={18} className="right-margin-smallest" />),
  [IconStatusType.ServicesInvalid]: (<XCircleFill size={18} className="right-margin-smallest" />),
  [IconStatusType.ConfigurationIssue]: (<ExclamationCircleFill size={18} className="right-margin-smallest" />),
  [IconStatusType.NotInitialised]: (<ExclamationCircleFill size={18} className="right-margin-smallest" />),
};

export interface IIconStatus {
  iconType: IconStatusType;
}
